import Outline from "./Outline";

export default {
  __init__: ["outline"],
  outline: ["type", Outline]
};
